export const redshiftConfigureDocLink =
  '/destinations/data-warehouses/amazon-redshift/#configure-amazon-redshift-as-a-destination';
export const postgresConfigureDocLink =
  '/destinations/databases/postgresql/#postgres-database-host';
export const hostUrlSection = 'destination-settings';
export const hostUrlLabel = 'host-url-field-help-text';
export const DEFAULT_MS_SQL_SCHEMA_NAME = 'dbo';


export enum MS_SQL_AUTH_METHOD {
  DATABASE_HOST = 'DATABASE_HOST',
  ENTRA_ID = 'ENTRA_ID'
}

export const MS_SQL_AUTH_OPTIONS = [
  { label: 'Username and Password', value: MS_SQL_AUTH_METHOD.DATABASE_HOST },
  { label: 'Microsoft Entra ID', value: MS_SQL_AUTH_METHOD.ENTRA_ID }
];
